import * as THREE from 'three';

export function disposeHierarchy(root: THREE.Object3D): void {
  root.traverse((obj) => {
    if (obj instanceof THREE.Mesh || obj instanceof THREE.Points || obj instanceof THREE.Line) {
      if (obj.geometry) {
        obj.geometry.dispose();
      }

      if (obj.material) {
        if (Array.isArray(obj.material)) {
          for (const mat of obj.material) {
            disposeMaterial(mat);
          }
        } else {
          disposeMaterial(obj.material);
        }
      }
    }
  });

  while (root.children.length > 0) {
    const child = root.children[0];
    root.remove(child);
  }
}

export function disposeMaterial(material: THREE.Material): void {
  // Dispose all associated textures
  for (const key of Object.keys(material)) {
    const value = (material as unknown as Record<string, unknown>)[key];
    if (value && typeof value === 'object' && 'isTexture' in value && (value as THREE.Texture).isTexture) {
      (value as THREE.Texture).dispose();
    }
  }
  material.dispose();
}
